"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStateStyles = exports.px = exports.getSpacingStyles = exports.getPropsStyles = exports.getColor = exports.getVariationBorderColor = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectSpread3 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _cssProps = require("./cssProps");

var getVariationBorderColor = function getVariationBorderColor(_ref) {
  var error = _ref.error,
      warning = _ref.warning;

  if (error) {
    return 'red70';
  }

  if (warning) {
    return 'yellow70';
  }

  return null;
};

exports.getVariationBorderColor = getVariationBorderColor;

var getColor = function getColor(selectors, fallbackColor, error, warning) {
  var variationBorderColor = getVariationBorderColor({
    error: error,
    warning: warning
  });
  return selectors.color(variationBorderColor || fallbackColor);
};

exports.getColor = getColor;

var getPropsStyles = function getPropsStyles(propsKeys, props) {
  var styles = {};
  propsKeys.forEach(function (propKey) {
    if (props[propKey]) {
      styles[propKey] = props[propKey];
    }
  });
  return styles;
};

exports.getPropsStyles = getPropsStyles;

var getSpacingStyles = function getSpacingStyles(propsKeys, props, spaceSelector) {
  var styles = {};
  propsKeys.forEach(function (propKey) {
    styles = (0, _objectSpread3.default)({}, styles, (0, _cssProps.cssValuesProp)(spaceSelector, props[propKey], propKey));
  });
  return styles;
};

exports.getSpacingStyles = getSpacingStyles;

var px = function px(value) {
  return typeof value === 'number' ? "".concat(value, "px") : value;
};

exports.px = px;

var getStateStyles = function getStateStyles(stateValues, borderColor) {
  var stateStyles = Object.keys(stateValues).reduce(function (_styles, stateKey) {
    return (0, _objectSpread3.default)({}, _styles, (0, _defineProperty2.default)({}, ":".concat(stateKey), stateValues[stateKey]));
  }, {});
  stateStyles[':focus'][':before'] = {
    borderColor: borderColor
  };
  return stateStyles;
};

exports.getStateStyles = getStateStyles;